import React, { useCallback, useEffect, useState } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import { Col, Modal, Row, Spinner } from 'react-bootstrap';
import Button from 'components/inputs/Button';
import { useDispatch, useSelector } from 'react-redux';
import * as _ from 'lodash';
import { startsWith } from 'components/common/utils';
import { DELETE_AMENITY, FETCH_AMENITY, GET_AMENITY } from 'actions/amenity';
import Avatar from 'components/inputs/Avatar';
import { RiDeleteBinLine } from 'react-icons/ri';
import { FiEdit2 } from 'react-icons/fi';
// import Pagination from 'components/general/Pagination';
import ReactPagination from 'components/general/ReactPagination';
import SearchBox from 'components/general/SearchBox';
import { BsSearch } from 'react-icons/bs';
import AmenityForm from './AmenityForm';
import DeleteModal from 'components/general/DeleteModal';
import { DELETE_STATUS_CODE } from 'components/common/constant';
import { BiSort } from 'react-icons/bi';

const AmenityList = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [allAmenities, setAllAmenities] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [amenityId, setAmenityId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });

  const page = useSelector((state) => state.amenity.page);
  const totalData = useSelector((state) => state.amenity.total);
  const limit = useSelector((state) => state.amenity.limit);
  const isLoader = useSelector((state) => state.amenity.isLoading);
  const amenityList = useSelector((state) => state.amenity.amenities);
  const totalPages = useSelector((state) => state.amenity.totalPages);

  const getAmenities = useCallback((data) => {
    dispatch({ type: FETCH_AMENITY, payload: data ? data : {} });
  }, []);

  const getAmenityDetail = useCallback((id) => {
    dispatch({ type: GET_AMENITY, payload: id });
  }, []);

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setAmenityId('');
  };

  const deleteAmenity = useCallback(
    () =>
      dispatch({
        type: DELETE_AMENITY,
        payload: amenityId,
        cb: (res) => {
          if (_.get(res, 'status', '') === DELETE_STATUS_CODE) {
            handleCloseDeleteModel();
            getAmenities({ page });
          }
        },
      }),
    [amenityId]
  );

  useEffect(() => {
    getAmenities();
  }, []);

  useEffect(() => {
    setAllAmenities(_.filter(amenityList, (item) => startsWith(_.get(item, 'name', ''), searchText)));
  }, [searchText, amenityList]);

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getAmenities(data);
      }
    },
    [sortByItem]
  );

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getAmenities(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getAmenities(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handleCloseFormModel = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title="Amenities" />
        <div className="page-content-wrapper scrollable">
          <div className="amenityList-page">
            <Card>
              <div className="amenityList-page-wrapper">
                <Row className="amenityList-search-box">
                  <Col xl={10} lg={9} md={8} className="amenityList-search-inputBox">
                    <SearchBox value={searchText} preIcon={<BsSearch />} onChange={(e) => setSearchText(e.target.value)} />
                  </Col>
                  <Col xl={2} lg={3} md={4} className="amenityList-search-boxButton">
                    <Button
                      className="amenityList-search-box-Btn"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      Add Amenity
                    </Button>
                  </Col>
                </Row>
                <div className="amenityList-table">
                  <div className="table-responsive">
                    <table className="record-list-table">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span>Amenities Name</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Amenities Icon</span>
                            </div>
                          </th>
                          <th className="action-col">
                            <div className="sorting">
                              <span>Action</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {isLoader ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="loader--block">
                                <Spinner as="span" animation="border" size="sm" role="status" />
                                <span className="ps-2">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : _.isEmpty(allAmenities) ? (
                          <tr>
                            <td colSpan={4} className="border-0">
                              <div className="empty-data-block">No amenity Data</div>
                            </td>
                          </tr>
                        ) : (
                          !(isLoader || _.isUndefined(isLoader)) &&
                          _.map(allAmenities, (item, key) => {
                            return (
                              <>
                                <tr key={`model-${key}`}>
                                  <td>{_.get(item, 'name', '')}</td>
                                  <td>
                                    <Avatar imgSrc={_.get(item, 'icon', '')} className="amenity-logo" />
                                  </td>
                                  <td>
                                    <span
                                      className="amenityList-table-editIcon"
                                      onClick={() => {
                                        setShowForm(true);
                                        getAmenityDetail(_.get(item, 'id'));
                                        setIsEdit(true);
                                      }}
                                    >
                                      <FiEdit2 />
                                    </span>
                                    <span
                                      className="amenityList-table-deleteIcon"
                                      onClick={() => {
                                        setShowDeleteModal(true);
                                        setAmenityId(_.get(item, 'id', ''));
                                      }}
                                    >
                                      <RiDeleteBinLine />
                                    </span>
                                  </td>
                                </tr>
                              </>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(allAmenities) && (
                  <ReactPagination
                    currentPage={page}
                    limit={limit}
                    total={totalData}
                    handlePageClick={(pageVal) => handlePageClick(pageVal)}
                    totalPages={totalPages}
                    marginPagesDisplayed={1}
                  />
                  // <Pagination currentPage={page} limit={limit} total={totalData} onPageChange={(pageVal) => handlePageClick(pageVal)} />
                )}
              </div>
            </Card>
          </div>
        </div>
        {showForm && (
          <Modal show={showForm} size="lg" centered>
            <AmenityForm onClose={handleCloseFormModel} isEdit={isEdit} onSuccess={getAmenities} />
          </Modal>
        )}
        {showDeleteModal && (
          <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
            <DeleteModal title="amenity" onClose={handleCloseDeleteModel} onRemove={deleteAmenity} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};

export default AmenityList;
